<div class="grid grid-cols-{{languages?.length}}" *ngIf="model.data.text">

  <div *ngFor="let lang of languages" class="p-1">
    <!--model.data.characterId:{{model.data.characterId}}//model.data.moodId:{{model.data.moodId}}
    <div>model.data.charIconURL:{{model.data.charIconURL}}</div>
    <img [src]="model.data.charIconURL">-->
    
    <app-dialog [image]="getCharacterMoodUrl(model.data.characterId, model.data.moodId)">
      <div [innerHtml]="model.data.text[lang]"></div>
      <div *ngIf="model.data.image?.data">
        <img [src]="model.data.image.data.fileURL" alt="img" class="w-8 h-8 my-0" *ngIf="model.data.image.data?.fileURL">
        <img [src]="model.data.image.data[lang].fileURL" alt="img" class="w-8 h-8 my-0" *ngIf="model.data.image.data[lang]?.fileURL">
      </div>
    </app-dialog>
  </div>
</div>
  